<!-- <div class="login-container">
  <div class="login-content" *ngIf="!(companyList && companyList.length > 0 && !selectedCompanyData)">
    <h2 class="heading1" style="display: flex;
   justify-content: center;
   margin-top: 3%;">MSME Login</h2>
    <mat-card>
      <form [formGroup]="loginForm" (ngSubmit)="login()">
        <div class="row" style="padding: 30px 30px 0px 30px;">
          <div class="col-md-12">
            <mat-form-field class="full-width" appearance="outline">
              <input type="text" matInput placeholder="Username" formControlName="userName">
            </mat-form-field>
          </div>
        </div>
        <div class="row" style="padding: 5px 30px 0px 30px;">
          <div class="col-md-12">
            <mat-form-field class="full-width" appearance="outline">
              <input [type]="isPwdVisible ? 'text' : 'password'" formControlName="password" autocomplete="false" matInput placeholder="Password">
              <mat-icon matSuffix class="pointer" (click)="isPwdVisible = !isPwdVisible">
                {{isPwdVisible ? 'visibility' : 'visibility_off'}}
              </mat-icon>
            </mat-form-field>
          </div>
        </div>



        <button style="display: flex; margin-left: 40%;margin-top: 10px;" type="submit" mat-raised-button
          color="primary" [disabled]="loginForm.invalid || isDisabled || loginWithSSO">Login</button>


           <button mat-raised-button type="button"  [disabled]="!loginWithSSO"  color="primary" (click)="loginSSO()" class="login-button">
            Login With SSO
          </button>

        <div class="mt-3 pt-2 ms-5 languageSelect">
          <mat-form-field style="width:80%;">
            <mat-select  placeholder="Select MultiLanguage" value="en" (selectionChange)="changeLanguge($event.value)">
              <mat-option  value="en">English</mat-option>
              <mat-option  value="hi">Hindi</mat-option>
            </mat-select>
          </mat-form-field> 

        </div>

      </form>


    
    </mat-card>
  </div>


   <div *ngIf="companyList && companyList.length > 0 && !selectedCompanyData"
    class="container-fluid min-vh-100 d-flex align-items-center justify-content-center ">
    <div class="card " style="max-width: 600px; width: 100%;">
      <div class="card-header">
        <h2 class="h4 mb-0">Select a Company</h2>
      </div>
      <div class="card-body p-5">
        <div class="mb-4">
          <label for="select-company" class="form-label" style="color: rgb(38 31 80)">Choose your company</label>
          <select id="select-company" class="form-select form-select-lg" [(ngModel)]="selectedCompany" name="company"
            (change)="onCompanyChange(selectedCompany)">
            <option *ngFor="let company of companyList" [ngValue]="company">
              {{ company.CompanyDisplayName }} ({{ company.CompanySchemaName }})
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>
</div> -->

<section class="login">
  
        <img style="padding-left: 10px;padding-top: 5px;
    height: 50px;
    width: 111px;" src="./assets/images/icons/logo.png" alt="SAP Business One" >

  

  <div class="innerWrap"  *ngIf="!(companyList && companyList.length > 0 && !selectedCompanyData)">
    <div class="row content">
    <div class="col-md-8">
      <div class="textWrap">
        <!-- <h6> {{'Language.HowERPWorks' | translate }}</h6> -->
        <p>{{'Language.ErpDesc' | translate }}</p>
      </div>
    </div>
    <div class="col-md-4">
      <div class="loginForm">
        <div class="intro">
                <img style="   
    height: 50px;
    width: 111px;" src="./assets/images/icons/logo.png" alt="SAP Business One" ><br>

          <!-- <span class="sub">{{'Language.WelcomeText' | translate}}</span>
          <p>{{'Language.SignInText' | translate}} <span>ET-Portal</span></p> -->
        </div>
         <form [formGroup]="loginForm" autocomplete="off" (ngSubmit)="login()">
        <div class="fieldGroup">
          <label for="email" class="form-label">{{'Language.userName' | translate}}</label>
          <input type="email" id="email" class="form-control" autocomplete="off"  placeholder="{{'Language.EnterUserName' | translate}}"  formControlName="userName">
        </div>
        <div class="fieldGroup">
          <label for="password" class="form-label">{{'Language.Password' | translate}}</label>
          <input type="password" id="password"   autocomplete="new-password" class="form-control" placeholder="{{'Language.EnterPassword' | translate}}" formControlName="password">
        </div>

          <button [ngClass]="{'disabled': loginForm.invalid}" class="loginBtn">
         {{'Language.SignIn' | translate}}
        </button>
        <!-- <div class="sep">
          <div class="text">{{'Language.ORCONTINUEWITH' | translate}}</div>
        </div>
        
        <button class="ssoLoginBtn"  (click)="loginSSO()"  [ngClass]="{'disabled': false}" >
          <img src="./assets/images/microsoft.svg" alt="microsoft">
           {{'Language.ContinuewithSSO' | translate}}
        </button> -->

      
</form>
      

       <!-- <div class="languageSelect">
  <mat-form-field appearance="fill" class="language-select-button">
    <mat-select placeholder="Select Language" value="en" (selectionChange)="changeLanguge($event.value)">
      <mat-option value="en">English</mat-option>
      <mat-option value="hi">हिंदी</mat-option>
    </mat-select>
  </mat-form-field>
</div> -->
 
<div class="languageSelect">
   <span>Select Language</span>
     <select #langSelect aria-label="Select Language" [(ngModel)]="selectLanguageValue"  (change)="changeLanguage(langSelect.value)">
  <option value="en" selected>English</option>
  <option value="hi">हिंदी</option>
</select>
    </div>
      </div>      
    </div>
  </div>
  </div>



  <div *ngIf="companyList && companyList.length > 0 && !selectedCompanyData"
    class="container-fluid min-vh-100 d-flex align-items-center justify-content-center ">
    <div class="card " style="max-width: 600px; width: 100%;">
      <div class="card-header">
        <h2 class="h4 mb-0">Select a Company</h2>
      </div>
      <div class="card-body p-5">
        <div class="mb-4">
          <label for="select-company" class="form-label" style="color: rgb(38 31 80)">Choose your company</label>
          <select id="select-company" class="form-select form-select-lg" [(ngModel)]="selectedCompany" name="company"
            (change)="onCompanyChange(selectedCompany)">
            <option *ngFor="let company of companyList" [ngValue]="company">
              {{ company.CompanyDisplayName }} ({{ company.CompanySchemaName }})
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>
</section>
  <!-- <span class="bottomText"> {{'Language.AccessErpText' | translate}}</span> -->
